// extracted by mini-css-extract-plugin
export default {"container":"Funds_container__hJ4y0"};